import { createMergeReducer } from '../utils/reducer'

export type TitleIdToBuyBoxTitleId = {
  [titleId: string]: string | undefined
}

export const reducer = createMergeReducer(
  t => t.buyboxTitleId,
  {} as TitleIdToBuyBoxTitleId
)
